import { FC, HTMLProps } from 'react';

export const ChIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ borderRadius: '50%' }}
      {...props}
    >
      <g clipPath="url(#clip0_1298_2846)">
        <path d="M0 0H24V24H0V0Z" fill="#EE1C25" />
        <path
          d="M9.59844 6.32469L3.47844 10.2847L5.99844 3.80469L8.15844 10.2847L2.39844 6.32469H9.59844Z"
          fill="#FFFF00"
        />
        <path
          d="M11.0858 2.95716L13.2665 4.02521L10.9839 4.41741L12.4636 2.68893L12.3211 5.01297L11.0858 2.95716Z"
          fill="#FFFF00"
        />
        <path
          d="M13.8685 5.07199L15.4627 6.90565L13.2059 6.37838L15.2429 5.36121L14.2066 7.44805L13.8685 5.07199Z"
          fill="#FFFF00"
        />
        <path
          d="M14.3682 8.55621L15.0752 10.8823L13.2294 9.47868L15.5054 9.3819L13.7063 10.8645L14.3682 8.55621Z"
          fill="#FFFF00"
        />
        <path
          d="M12.4677 11.0436L12.2223 13.4598L11.0625 11.4546L13.1973 12.243L10.9677 12.9156L12.4677 11.0436Z"
          fill="#FFFF00"
        />
      </g>
      <defs>
        <clipPath id="clip0_1298_2846">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
